import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import ParallaxHero from '@/components/home/ParallaxHero';
import CategorySection from '@/components/home/CategorySection';
import DealsCarousel from '@/components/home/DealsCarousel';
import FeaturedProducts from '@/components/home/FeaturedProducts';

const Home = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-background"
      data-testid="home-page"
    >
      <Navbar />
      <main>
        <ParallaxHero />
        <CategorySection />
        <DealsCarousel />
        <FeaturedProducts />
      </main>
      <Footer />
    </motion.div>
  );
};

export default Home;
